export default __webpack_public_path__ + "static/media/Verifiaction Color.1d125cd5.svg";